<template>
    <div class="content">
        <h1 class="is-1">
            {{ $route.params.id }}
        </h1>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'apps',
    data() {
        return {};
    }
}
</script>

<style scoped>

</style>
